var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pruebas-wrap"},[_c('div',{ref:"host",staticClass:"pruebas-host"}),(_vm.error)?_c('p',{staticClass:"pruebas-error"},[_vm._v(" No pudimos cargar el detalle de las pruebas. Inicia sesión y descárgalas: son gratis. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }